import { memo } from 'react';

import { Portal } from '@air/primitive-portal';

import { CopyToWorkspacePanel } from '~/components/CopyToWorkspace/CopyToWorkspacePanel';
import { PublicZippingTasksPanel } from './ZippingTasks/PublicZippingTasksPanel';

export const PublicBoardActivityContainer = memo(() => {
  return (
    <Portal>
      <div className="fixed right-4 bottom-6 z-1">
        <CopyToWorkspacePanel />
        <PublicZippingTasksPanel />
      </div>
    </Portal>
  );
});

PublicBoardActivityContainer.displayName = 'PublicBoardActivityContainer';
